import { parse, stringify } from 'superjson'
import { PersistStorage, StorageValue } from 'zustand/middleware/persist'

/**
 * Factory function to create a local storage interface with methods for getting,
 * setting and removing items. It uses SuperJSON to handle serialization and
 * deserialization, supporting complex data types.
 *
 * @returns An object containing methods for interacting with local storage.
 */
export function createStorage<S>(): PersistStorage<S> {
  return {
    getItem: async (name: string): Promise<StorageValue<S> | null> => {
      const item = localStorage.getItem(name)
      if (!item) return null
      return parse<StorageValue<S>>(item)
    },
    setItem: (name: string, value: StorageValue<S>) => {
      localStorage.setItem(name, stringify(value))
    },
    removeItem: (name: string) => {
      localStorage.removeItem(name)
    }
  }
}
